module.exports = __webpack_public_path__ + "static/media/totalPositionsIcon.cd321dbf.svg";